module.exports = __webpack_public_path__ + "static/media/tap_07_img02.714cc11a.png";